defineGlobalOnce(
  'ThemeSection_tourEvents',
  ({
    source,
    songkick,
    bandsintown,
    eventbriteToken,
    maxEvents,
    useExternalSource,
  }) => {
    return {
      eventData: [],
      rawEvents: {
        songkick: [],
        bandsintown: [],
        eventbrite: [],
      },
      source: source || '',
      maxEvents:
        maxEvents === 'all'
          ? -1
          : parseInt(maxEvents),
      moreLinkUrl: '',
      storeLocale: window.theme.locale || 'en',
      getDayFromDate(date) {
        return new Intl.DateTimeFormat(this.storeLocale, {
          day: 'numeric',
        }).format(Date.parse(date));
      },
      getMonthFromDate(date) {
        return new Intl.DateTimeFormat(this.storeLocale, {
          month: 'short',
        }).format(Date.parse(date));
      },
      fetchEvents() {
        if (useExternalSource === false) {
          const rawData = JSON.parse(
            this.$el.querySelector('[data-event-data]').innerHTML,
          );
          this.eventData = rawData.events;
        } else {
          switch (this.source) {
            case 'songkick': {
              const artistId = songkick;
              const url = `//api.songkick.com/api/3.0/artists/${artistId}/calendar.json?apikey=aeff44DVdi0z3VT6`;

              const responsePromise = fetch(url);
              responsePromise
                .then((resp) => resp.json())
                .then((data) => {
                  this.rawEvents.songkick = data.resultsPage.results.event;
                  this.moreLinkUrl = `https://www.songkick.com/artists/${artistId}`;
                  this.processSongkickEvents();
                })
                .catch((error) => {
                  console.warn('error fetching songkick data:', error);
                });
              break;
            }
            case 'bandsintown': {
              const artistName = bandsintown;
              const bandsintownName = artistName
                .toLowerCase()
                .replace(' ', '%20');
              const bandsintownSlug = bandsintownName.replace('%20', '');
              const url = `//rest.bandsintown.com/artists/${bandsintownName}/events?app_id=girafficthemes`;

              const responsePromise = fetch(url);
              responsePromise
                .then((resp) => resp.json())
                .then((data) => {
                  this.rawEvents.bandsintown = JSON.parse(JSON.stringify(data));
                  this.moreLinkUrl = `https://www.bandsintown.com/${bandsintownSlug}`;
                  this.processBandsintownEvents();
                })
                .catch((error) => {
                  console.warn('error fetching bandsintown data:', error);
                });
              break;
            }
            case 'eventbrite': {
              const token = eventbriteToken;
              const apiUrl = 'https://www.switchthemes.co/.netlify/functions/get-eventbrite-events';
              const data = { token: token };
              fetch(apiUrl, {
                method: 'POST', // or 'PUT'
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
              })
              .then(response => response.json())
              .then(data => {
                this.rawEvents.eventbrite = data.events;
                if (data.events[0]) {
                  const firstEvent = data.events[0];

                  if (firstEvent.organizer && firstEvent.organizer.url) {
                    this.moreLinkUrl = firstEvent.organizer.url;
                  }
                }

                this.processEventbriteEvents();
              })
              .catch((error) => {
                //this.error = "Sorry, looks like something went wrong. Please try again.";
              });
              break;
            }
          }
        }
      },
      processSongkickEvents() {
        let events = this.rawEvents.songkick.map((event) => {
          return {
            day: ('0' + this.getDayFromDate(event.start.date)).slice(-2),
            month: this.getMonthFromDate(event.start.date),
            name: event.displayName,
            location: event.location.city,
            url: event.uri,
          };
        });

        if (this.maxEvents !== -1) {
          this.eventData = events.slice(0, this.maxEvents);
        } else {
          this.eventData = events;
        }
      },
      processBandsintownEvents() {
        let events = this.rawEvents.bandsintown.map((event) => {
          let eventLocation;

          if (event.venue.location.indexOf(event.venue.country) !== -1) {
            eventLocation = event.venue.location;
          } else {
            eventLocation = `${event.venue.location}, ${event.venue.country}`;
          }

          return {
            day: ('0' + this.getDayFromDate(event.datetime)).slice(-2),
            month: this.getMonthFromDate(event.datetime),
            name: event.venue.name,
            location: eventLocation,
            url: event.url,
          };
        });

        if (this.maxEvents !== -1) {
          this.eventData = events.slice(0, this.maxEvents);
        } else {
          this.eventData = events;
        }
      },
      processEventbriteEvents() {
        let events = this.rawEvents.eventbrite.map((event) => {
          let eventLocation;

          if (event.online_event === true) {
            eventLocation = window.theme.strings.onlineEvent || 'Online event';
          } else if (event.venue) {
            eventLocation = `${event.venue.name} &#183; ${event.venue.address.city}, ${event.venue.address.country}`;
          }

          return {
            day: ('0' + this.getDayFromDate(event.start.local)).slice(-2),
            month: this.getMonthFromDate(event.start.local),
            name: event.name.text,
            location: eventLocation,
            url: event.url,
          };
        });
        if (this.maxEvents !== -1) {
          this.eventData = events.slice(0, this.maxEvents);
        } else {
          this.eventData = events;
        }
      },
    };
  },
);
